import { useState } from 'react'
import { useUpdateEffect } from 'react-use'

import { isBrowser } from '~lib/helpers'

type UseGetElementById = (id: string) => HTMLElement

const useGetElementById: UseGetElementById = (id) => {
  const [element, setElement] = useState<HTMLElement>(() => (isBrowser() ? document.getElementById(id) : null))

  useUpdateEffect(() => {
    const possiblyElement = document.getElementById(id)

    if (possiblyElement) {
      setElement(possiblyElement)
    }
  }, [id])

  return element
}

export default useGetElementById
